enum NavegadorAcaoEnum {
  NAV_UTIL_CONTEUDO_CURTIR,
  NAV_UTIL_ALERTA_MENSAGEM_NAO_PREENCHIDO,
}

export default NavegadorAcaoEnum;
